import { render, staticRenderFns } from "./startCalculation.vue?vue&type=template&id=d9629cec&scoped=true"
import script from "./startCalculation.vue?vue&type=script&lang=js"
export * from "./startCalculation.vue?vue&type=script&lang=js"
import style0 from "./startCalculation.vue?vue&type=style&index=0&id=d9629cec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9629cec",
  null
  
)

export default component.exports